<div class="mt-3 mb-3">
  <app-input-text class="w-100"
                  [label]="'Email para contato'"
                  [placeholder]="''" [id]="'emailContato'"
                  [readonly]="true"
                  [value]="novoParceiroService.model?.email"
  ></app-input-text>
</div>

<div class="d-flex justify-content-center" style="margin-top: 5rem; margin-bottom: 2rem;">
  <button class="botao-primario w-100 texto-inter texto-semi-bold" type="button" id="realizarLogin" (click)="irParaSite()">
    Ir para site PJUS
  </button>
</div>
<div class="w-100 d-flex justify-content-center align-content-center">
  <a style='margin-right: 0.75rem' href='https://pjus.com.br/' target='_blank'>
    <img alt='' src='https://framework.pjus.com.br/assets/icons/web.svg'/>
  </a>
  <a href='https://www.instagram.com/pjusbrasil/' style='margin-right: 0.75rem' target='_blank'>
    <img alt='' src='https://framework.pjus.com.br/assets/icons/instagram.svg'/>
  </a>
  <a href='https://br.linkedin.com/company/pjusbrasil' target='_blank'>
    <img alt='' src='https://framework.pjus.com.br/assets/icons/linkedin.svg'/>
  </a>
</div>
